import React from 'react';
import PropTypes from 'prop-types';
import TTSourceColumns from './c/ttSourceColumn/TTSourceColumn';
import { ARRAY_OF_NAME_LABEL_PROP_TYPE, TARGET_FIELDS_PROP_TYPE } from 'shared/constants/PropTypes';
import TTTargetColumns from './c/ttTargetColumn/TTTargetColumn';
import TTAddColumn from './c/ttAddColumn/TTAddColumnsConnector';

class TTColumnManager extends React.Component {

  handleSourceColumnChange = (id, value, index) => {
    this.props.ttActions.updateSourceColumn(id, value, index);
  };

  handleTargetColumnChange = (id, value) => {
    this.props.ttActions.updateTargetColumn(id, value);
  };

  render() {
    const { sourceColumns, targetFields, sourceFields, targetColumn, translationTableId } = this.props;
    return (
      <div className={ 'tt-column-manager' }>
        <div className={ 'tt-column-manager__headers' }>
          {
            sourceColumns.map((source, index) => (
              <div key={ source.id } className={ 'tt-column-manager__header' }>{ `${ sourceColumns[index].sourceField ? 'Input Data Columns' : '' }`}</div>
            ))
          }
          <div className={ 'tt-column-manager__header-separator' } />
          <div className={ 'tt-column-manager__header' }>{`${ targetColumn.sourceField ? 'Sovos System Columns' : '' }`}</div>
        </div>
        <div className={ 'tt-column-manager__columns' }>
          {
            sourceColumns.map((source, index) => (
              <div key={ source.id } className={ 'tt-column-manager__column' }>
                <TTSourceColumns
                  value= { sourceColumns[index] ? sourceColumns[index].sourceField : '' }
                  sourceColumnId={ source.id }
                  sourceFields={ sourceFields }
                  onValueChange={ (id, value) => this.handleSourceColumnChange(id, value, index) }
                />
              </div>
            ))
          }
          <TTAddColumn translationTableId={ translationTableId } disabled={ true /* sourceColumns.length > 5 */ } />
          <div className={ 'tt-column-manager__column' }>
            { 
              targetColumn && 
              <TTTargetColumns 
                value= { targetColumn.sourceField }
                targetColumnId={ targetColumn.id } 
                targetFields={ targetFields } 
                onValueChange={ (id, value) => this.handleTargetColumnChange(id, value) }
              /> 
            }
          </div>
        </div>
      </div>
    );
  }
}

TTColumnManager.propTypes = {
  translationTableId: PropTypes.number.isRequired,
  sourceColumns: PropTypes.arrayOf(PropTypes.object).isRequired,
  targetColumn: PropTypes.object.isRequired,
  targetFields: TARGET_FIELDS_PROP_TYPE.isRequired,
  sourceFields: ARRAY_OF_NAME_LABEL_PROP_TYPE.isRequired,
  ttActions: PropTypes.shape({
    updateSourceColumn: PropTypes.func,
    updateTargetColumn: PropTypes.func
  }).isRequired
};

export default TTColumnManager;



// WEBPACK FOOTER //
// ./src/shared/components/translationTable/c/ttColumnManager/TTColumnManager.js